export type SurveyConfig = {
  id: string;
  url: string;
};

const FEEDBACK_SURVEY = {
  id: 'panrpDJf',
  url: 'https://survey.porsline.ir/embed/eyJib3JkZXIiOiJub25lIiwid2lkdGgiOiIxMDAlIiwiaGVpZ2h0IjoiMTAwJSJ9/panrpDJf',
} satisfies SurveyConfig;

export const PORSLINE = {
  feedback: FEEDBACK_SURVEY,
  businessAnalysis: FEEDBACK_SURVEY,
} satisfies Record<string, SurveyConfig>;
